import React, { useRef, useState } from 'react';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

/* ═══════════════════════════════════════════════════════════════════════════════
   SALOMON × WUNDER — Eylül · Ekim · Kasım 2026 İŞ BİRLİĞİ TEKLİFİ
   Aylık ₺150.000 medya (Meta ₺90K + Google ₺60K)
   + Ana sayfa First Banner (rate card ₺45.000/ay) — taahhüt karşılığı DAHİL
   + E-posta (rate card ₺35.000/ay) — taahhüt karşılığı DAHİL

   TÜM BİRİM MALİYET VE ENVANTER RAKAMLARI WUNDER'IN KENDİ GERÇEKLEŞEN VERİSİNDEN:
   · GA4 (wunder.com.tr) — sayfa görüntülenmesi, kanal grubu, marka ilgisi · Ağu 2025-Tem 2026
   · unified_ad_platform_daily_summary — Meta/Google gerçekleşen CPM-CPC-CTR · son 12 ay
   · ikas — Salomon satış adedi/cirosu, müşteri tabanı
   Uydurulmuş envanter rakamı YOKTUR.
   NOT (12 Ağu 2026): kullanıcı isteğiyle envanter/rakip/3 aylık kurgu/projeksiyon
   bölümleri ve Metodoloji notu sayfadan kaldırıldı; sayfa Teklif Özeti + Aylık
   Medya Planı + Ölçümleme olarak sadeleşti. Rakamların dayanağı proje notundadır.
   ═══════════════════════════════════════════════════════════════════════════════ */

/* Üstü çizili fiyat. html2canvas'ta `line-through` da, inline-block içine konan
   `absolute` çizgi de rakamın TEPESİNE kayıyor (mutlak konumlu çocuğun offset'ini
   0 alıyor) — PDF çıktısında görünür hata. Çizgi bu yüzden arka plan gradyanı
   olarak çiziliyor: konumlama yok, satırın 9-10. pikseli boyanıyor. */
const CiziliBaglam = React.createContext(false);

function Cizili({ children }) {
  const pdfModu = React.useContext(CiziliBaglam);
  // html2canvas metni satır kutusu içinde ~8px aşağı çiziyor; yakalama sırasında
  // çizgi de aynı kadar aşağı alınmazsa PDF'te rakamın TEPESİNDE görünüyor.
  const cizgi = pdfModu
    ? 'bg-[linear-gradient(transparent_17px,#9ca3af_17px,#9ca3af_18px,transparent_18px)]'
    : 'bg-[linear-gradient(transparent_9px,#9ca3af_9px,#9ca3af_10px,transparent_10px)]';
  return <span className={`inline-block leading-5 text-gray-400 ${cizgi}`}>{children}</span>;
}

export default function SalomonWunderEylulKasim2026() {
  const kartRef = useRef(null);
  const [indiriliyor, setIndiriliyor] = useState(false);
  const [pdfModu, setPdfModu] = useState(false);

  /* Teklif kartını tek sayfalık PDF olarak indir. Sayfa bölme yok: PDF sayfa
     boyutu içeriğin en-boy oranına eşitlenir, böylece tablo hiçbir yerden
     kesilmez. Yakalama 2× ölçekte yapılır, PDF'e 1× boyutta basılır. */
  const pdfIndir = async () => {
    if (!kartRef.current || indiriliyor) return;
    setIndiriliyor(true);
    setPdfModu(true);
    await new Promise((r) => setTimeout(r, 200)); // stil değişimi boyansın
    try {
      const tuval = await html2canvas(kartRef.current, {
        scale: 2, backgroundColor: '#ffffff', useCORS: true, logging: false,
        imageTimeout: 15000, windowWidth: kartRef.current.scrollWidth,
      });
      const g = tuval.width / 2, y = tuval.height / 2;
      const pdf = new jsPDF({ orientation: g > y ? 'landscape' : 'portrait', unit: 'px', format: [g, y] });
      pdf.addImage(tuval.toDataURL('image/jpeg', 0.95), 'JPEG', 0, 0, g, y);
      pdf.save('salomon-wunder-eylul-kasim-2026.pdf');
    } catch (e) {
      alert(`PDF alınamadı: ${e.message}`);
    } finally {
      setPdfModu(false);
      setIndiriliyor(false);
    }
  };

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="mb-4 flex justify-end">
        <button
          onClick={pdfIndir}
          disabled={indiriliyor}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-gray-800 text-white text-sm font-semibold hover:bg-gray-700 disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {indiriliyor ? 'Hazırlanıyor…' : 'PDF İndir'}
        </button>
      </div>
      <CiziliBaglam.Provider value={pdfModu}>
      <div ref={kartRef} className="bg-white rounded-2xl shadow-sm border overflow-hidden">

        {/* ─────────────────────────── BAŞLIK ─────────────────────────── */}
        <div className="bg-white border-b p-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="flex flex-shrink-0 items-center gap-4 pr-5 border-r border-gray-200">
              <img src="/salomon_logo.png" alt="Salomon" className="h-11 w-auto object-contain" />
              <span className="text-gray-300 text-xl font-light leading-none">×</span>
              <img src="/wunderlogo.webp" alt="Wunder" className="h-4 w-auto object-contain" />
            </div>
            <div className="ml-1">
              <h2 className="text-lg font-bold text-gray-800">Salomon × Wunder | Eylül · Ekim · Kasım 2026 İş Birliği Teklifi</h2>
              <p className="text-sm text-gray-500">
                Aylık ₺150.000 performans medyası (Meta + Google) • Ana sayfa First Banner • E-posta • 3 ay
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-block whitespace-nowrap px-3 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full border border-gray-200">
              Eyl–Kas 2026
            </span>
            <span className="inline-block whitespace-nowrap px-3 py-1.5 bg-gray-800 text-white text-sm font-semibold rounded-full">
              3 Ay Toplam: ₺450.000
            </span>
          </div>
        </div>

        <div className="p-6">

          {/* ─────────────────────── TEKLİF ÖZETİ ─────────────────────── */}
          <div className="mb-8 rounded-xl border-2 border-gray-800 overflow-hidden">
            <div className="bg-gray-800 px-4 py-3 text-white font-semibold flex items-center justify-between">
              <span>Teklif Özeti | Aylık Paket</span>
              <span className="text-[11px] font-normal text-gray-300">Rate card değeri ₺230.000 → ödenen ₺150.000</span>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[12px]">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2.5 text-left font-medium uppercase tracking-wider text-[11px]">Kalem</th>
                    <th className="px-4 py-2.5 text-left font-medium uppercase tracking-wider text-[11px]">Kapsam</th>
                    <th className="px-4 py-2.5 text-right font-medium uppercase tracking-wider text-[11px]">Rate Card</th>
                    <th className="px-4 py-2.5 text-right font-medium uppercase tracking-wider text-[11px]">Bu Teklifte</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  <tr>
                    <td className="px-4 py-3 font-medium">Meta Ads | medya</td>
                    <td className="px-4 py-3">Advantage+ Katalog · Prospecting · Retargeting | <strong>tamamı ürün feed'inden</strong></td>
                    <td className="px-4 py-3 text-right">₺90.000</td>
                    <td className="px-4 py-3 text-right font-semibold">₺90.000</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 font-medium">Google Ads | medya</td>
                    <td className="px-4 py-3">Search (marka + kategori) · Shopping / PMax | <strong>feed tabanlı</strong></td>
                    <td className="px-4 py-3 text-right">₺60.000</td>
                    <td className="px-4 py-3 text-right font-semibold">₺60.000</td>
                  </tr>
                  <tr className="bg-amber-50/50">
                    <td className="px-4 py-3 font-medium">Ana Sayfa <strong>First Banner</strong></td>
                    <td className="px-4 py-3">30 gün · %100 SOV · masaüstü + mobil · <strong>219.358 gösterim/ay</strong></td>
                    <td className="px-4 py-3 text-right"><Cizili>₺45.000</Cizili></td>
                    <td className="px-4 py-3 text-right font-semibold text-emerald-700">DAHİL</td>
                  </tr>
                  <tr className="bg-amber-50/50">
                    <td className="px-4 py-3 font-medium">E-posta Pazarlama</td>
                    <td className="px-4 py-3">Ayda 3 gönderim · <strong>153.927 teslim/ay</strong> (1 solo + 2 yerleşim)</td>
                    <td className="px-4 py-3 text-right"><Cizili>₺35.000</Cizili></td>
                    <td className="px-4 py-3 text-right font-semibold text-emerald-700">DAHİL</td>
                  </tr>
                  <tr className="bg-gray-800 text-white font-bold">
                    <td className="px-4 py-3">AYLIK TOPLAM</td>
                    <td className="px-4 py-3 font-normal text-[11px] text-gray-300">Performans medyası + Wunder owned envanteri</td>
                    <td className="px-4 py-3 text-right"><Cizili>₺230.000</Cizili></td>
                    <td className="px-4 py-3 text-right text-lg">₺150.000</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* ─────────────── MEDYA PLANI ─────────────── */}
          <div className="mb-8 rounded-xl border overflow-hidden">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Aylık Medya Planı | ₺150.000 (Meta ₺90.000 + Google ₺60.000)</div>
            <div className="px-4 py-3 bg-violet-50 border-b border-violet-100 text-[11px] text-violet-900 leading-relaxed">
              <strong>Kurgunun tamamı ürün kataloğu (feed) üzerine kuruludur.</strong> Video ve prodüksiyon gerektiren kampanya
              (Meta Reels prospecting, YouTube in-stream) plandan bilinçli olarak çıkarılmıştır: Salomon'un Türkiye pazarına
              hazır video/kreatif envanteri sınırlıdır ve kampanyanın <strong>içerik üretimine bağımlı olmaması</strong> önceliklidir.
              Bunun yerine tüm bütçe, Wunder'ın Merchant Center ve Meta kataloğundaki <strong>gerçek Salomon ürün görselleri,
              fiyatları ve stok durumu</strong> ile çalışan kampanyalara verildi — bu kampanyalar kreatif beklemeden, feed
              güncellendiği anda yayına girer. Salomon'dan tek beklenti <strong>ürün görsellerinin ve model adlarının doğruluğu</strong>.
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Mecra</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Kampanya</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Hedef Kitle</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Aylık Tahmini Çıktı</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Bütçe</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-[12px] text-gray-700">
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium align-top" rowSpan={3}>
                      <div className="flex items-center gap-2"><img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" /><span>Meta Ads</span></div>
                    </td>
                    <td className="px-4 py-3">Advantage+ Katalog | Prospecting</td>
                    <td className="px-4 py-3">Geniş + benzer kitle · Salomon ürün seti izole katalog · ürün görseli feed'den</td>
                    <td className="px-4 py-3">468.100 gösterim · 18.730 tıklama</td>
                    <td className="px-4 py-3 text-right font-medium">₺42.000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Advantage+ Katalog | Retargeting (DPA)</td>
                    <td className="px-4 py-3">Salomon ürün sayfası görüntüleyen + sepete ekleyen (30 gün) · dinamik ürün hatırlatma</td>
                    <td className="px-4 py-3">312.100 gösterim · 12.480 tıklama</td>
                    <td className="px-4 py-3 text-right font-medium">₺28.000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Katalog | Sezon Kategorisi</td>
                    <td className="px-4 py-3">Feed'den otomatik kurulur | Eylül trail, Ekim su geçirmez bot, Kasım BF ürün grubu</td>
                    <td className="px-4 py-3">223.000 gösterim · 8.920 tıklama</td>
                    <td className="px-4 py-3 text-right font-medium">₺20.000</td>
                  </tr>
                  <tr className="bg-indigo-50 font-semibold text-indigo-800">
                    <td className="px-4 py-3" colSpan={3}>Meta Ads Toplam</td>
                    <td className="px-4 py-3">1.003.200 gösterim · 40.130 tıklama · CPM ₺89,7 · CPC ₺2,24</td>
                    <td className="px-4 py-3 text-right">₺90.000</td>
                  </tr>

                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium align-top" rowSpan={3}>
                      <div className="flex items-center gap-2"><img src="/google_ads-512.webp" alt="Google Ads" className="w-5 h-5 object-contain" /><span>Google Ads</span></div>
                    </td>
                    <td className="px-4 py-3">Shopping / PMax | Salomon feed</td>
                    <td className="px-4 py-3">Merchant Center'da Salomon ürünleriyle sınırlı feed etiketi · en yüksek paylı kalem</td>
                    <td className="px-4 py-3">222.222 gösterim · 5.113 tıklama · CPC ₺4,89</td>
                    <td className="px-4 py-3 text-right font-medium">₺25.000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Search | Marka</td>
                    <td className="px-4 py-3">"salomon", "salomon xt-6", "salomon speedcross", "salomon bot" · marka + model aramaları</td>
                    <td className="px-4 py-3">87.156 gösterim · 3.661 tıklama · CPC ₺5,19</td>
                    <td className="px-4 py-3 text-right font-medium">₺19.000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Search | Kategori (non-brand)</td>
                    <td className="px-4 py-3">"trail koşu ayakkabısı", "outdoor bot", "patika ayakkabısı", "su geçirmez bot"</td>
                    <td className="px-4 py-3">76.923 gösterim · 2.219 tıklama · CPC ₺7,21</td>
                    <td className="px-4 py-3 text-right font-medium">₺16.000</td>
                  </tr>
                  <tr className="bg-blue-50 font-semibold text-blue-800">
                    <td className="px-4 py-3" colSpan={3}>Google Ads Toplam</td>
                    <td className="px-4 py-3">386.301 gösterim · 10.993 tıklama · CPM ₺155 · CPC ₺5,46</td>
                    <td className="px-4 py-3 text-right">₺60.000</td>
                  </tr>

                  <tr className="hover:bg-amber-50/40 bg-amber-50/20">
                    <td className="px-4 py-3 font-medium align-top" rowSpan={2}>
                      <div className="flex items-center gap-2"><span className="w-5 h-5 rounded bg-amber-400 inline-block" /><span>Wunder Owned</span></div>
                    </td>
                    <td className="px-4 py-3">Ana Sayfa First Banner</td>
                    <td className="px-4 py-3">Siteye giren herkes · %100 SOV · masaüstü + mobil ayrı görsel</td>
                    <td className="px-4 py-3"><strong>219.358 gösterim</strong> · ~1.750 tıklama</td>
                    <td className="px-4 py-3 text-right font-medium"><Cizili>₺45.000</Cizili></td>
                  </tr>
                  <tr className="hover:bg-amber-50/40 bg-amber-50/20">
                    <td className="px-4 py-3">E-posta | 3 gönderim</td>
                    <td className="px-4 py-3">51.309 aktif müşteri · 1 solo Salomon + 2 bülten yerleşimi</td>
                    <td className="px-4 py-3"><strong>153.927 teslim</strong> · 3 gönderim</td>
                    <td className="px-4 py-3 text-right font-medium"><Cizili>₺35.000</Cizili></td>
                  </tr>

                  <tr className="bg-gray-800 text-white font-bold">
                    <td className="px-4 py-3" colSpan={3}>AYLIK GENEL TOPLAM</td>
                    <td className="px-4 py-3">1.762.786 gösterim/teslim · 52.873 tıklama</td>
                    <td className="px-4 py-3 text-right">₺150.000</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-3 bg-slate-50 border-t text-[11px] text-gray-600 leading-relaxed">
              Tablodaki gösterim/tıklama rakamları <strong>aylıktır</strong>.
            </div>
          </div>


        </div>
      </div>
      </CiziliBaglam.Provider>
    </div>
  );
}
